import { SIZE } from '@ui-components/typography/PlayText';
import { CategoryFragment } from 'app/graphql/__generated__/types/contento';
import Link from 'next/link';
import React from 'react';
import { Category, CategoryHeading, CategoryLink, CategoryList, StyledCategories } from './Categories.styles';

export type CategoriesProps = {
    categories: CategoryFragment[];
};

export const Categories = ({ categories }: CategoriesProps) => (
    <StyledCategories>
        <CategoryHeading>Kategorier</CategoryHeading>
        <CategoryList>
            {categories &&
                categories.map((category, i) => {
                    // Next.js redirects only works server side
                    const link = ['teckensprak', 'syntolkat'].includes(category.id)
                        ? `/${category.id}`
                        : `/kategori/${category.id}`;

                    return (
                        <Category key={`category-${i}`} data-rt="details-page-genre-link">
                            <Link href={link} passHref>
                                <CategoryLink size={SIZE.MINI}>{category.heading}</CategoryLink>
                            </Link>
                        </Category>
                    );
                })}
        </CategoryList>
    </StyledCategories>
);
export default Categories;
